import { type AccountActivityItem } from '@/portal-api.definition';

export function getDevice(activity: AccountActivityItem) {
  if (activity.DeviceModel) {
    return activity.DeviceModel;
  }
  if (activity.Browser) {
    return activity.Browser;
  }
  if (activity.Os) {
    return activity.Os;
  }

  return null;
}

/** Strip trailing version numbers: "Chrome 146" → "Chrome", "Mac OS X 10" → "Mac OS X" */
export function normalizeDeviceName(name: string): string {
  return name.replace(/\s+\d+(?:\.\d+)*$/, '');
}

/**
 * Group raw device names by their normalized (version-stripped) form.
 * e.g. ["Chrome 146", "Chrome 147", "Firefox 150"] → Map { "Chrome" → ["Chrome 146", "Chrome 147"], "Firefox" → ["Firefox 150"] }
 */
export function createDeviceGroupMap(devices: string[]): Map<string, string[]> {
  const groups = new Map<string, string[]>();
  for (const device of devices) {
    const normalized = normalizeDeviceName(device);
    const group = groups.get(normalized);
    if (group) {
      group.push(device);
    } else {
      groups.set(normalized, [device]);
    }
  }
  return groups;
}
